import {
  AuthAccountContactTypeChoices,
  ContactType,
  Loading,
  PersonalInfoFormContent,
  TPersonalInformationFormData,
  UserTypeEnum,
} from "@cpj-ai/panel-npm-package";
import { AdminJobSeekerType, AuthAccountUserOrderByChoices, useGetJobSeekerByIdQuery } from "@graphql/generated";
import { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";

const PersonalInformation = () => {
  const { id } = useParams();
  const { data, loading, error, refetch } = useGetJobSeekerByIdQuery({
    variables: {
      id: id || "",
    },
  });

  const formHandler = useForm<TPersonalInformationFormData & { orderBy: AuthAccountUserOrderByChoices }>();

  const getContactByType = (
    contacts: (ContactType | null)[] | null | undefined,
    type: AuthAccountContactTypeChoices,
  ): string | undefined => {
    return contacts?.find((item) => item?.type === type)?.value;
  };

  const initializeFormData = useCallback(
    (jobSeeker: AdminJobSeekerType | undefined) => {
      if (!jobSeeker) return;

      formHandler.reset({
        firstName: jobSeeker.firstName,
        lastName: jobSeeker.lastName,
        gender: jobSeeker.profile?.gender || undefined,
        birthDate: jobSeeker.profile?.birthDate || undefined,
        country: jobSeeker.profile?.city?.country,
        region: jobSeeker.profile?.city?.region,
        city: { node: jobSeeker.profile?.city },
        email: jobSeeker.email,
        phone: getContactByType(jobSeeker.profile?.contacts, AuthAccountContactTypeChoices.PHONE),
        whatsapp: getContactByType(jobSeeker.profile?.contacts, AuthAccountContactTypeChoices.WHATSAPP),
        linkedin: getContactByType(jobSeeker.profile?.contacts, AuthAccountContactTypeChoices.LINKEDIN),
        website: getContactByType(jobSeeker.profile?.contacts, AuthAccountContactTypeChoices.WEBSITE),
        address: getContactByType(jobSeeker.profile?.contacts, AuthAccountContactTypeChoices.ADDRESS),
        allowNotifications: jobSeeker.profile?.allowNotifications,
        orderBy: AuthAccountUserOrderByChoices.DATE_JOINED,
      });
    },
    [formHandler],
  );

  useEffect(() => {
    if (data?.admin?.jobSeekers?.edges[0]?.node) {
      initializeFormData(data?.admin?.jobSeekers?.edges[0]?.node as AdminJobSeekerType);
    }
  }, [data, formHandler, initializeFormData]);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <div>Error loading job seeker information</div>;
  }

  return (
    <PersonalInfoFormContent
      formHandler={formHandler}
      previewMode={true}
      wrapInCard={false}
      showCancel={false}
      profile={{
        email: data?.admin?.jobSeekers?.edges[0]?.node?.email,
        name:
          [data?.admin?.jobSeekers?.edges[0]?.node?.firstName, data?.admin?.jobSeekers?.edges[0]?.node?.lastName]
            .filter(Boolean)
            .join(" ") || undefined,
        avatar: data?.admin?.jobSeekers?.edges[0]?.node?.profile?.avatar?.file ?? undefined,
      }}
      fetchProfile={refetch}
      userType={UserTypeEnum.ADMIN}
    />
  );
};

export default PersonalInformation;
